import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const getProductDetails = async (reference) => {
  const path = `/products/${encodeURIComponent(reference)}/`;
  try {
    const response = await axiosInstance.get(path);
    return response.data;
  } catch (error) {
    console.error('Products Details API error:', error);
    throw error;
  }
};

export const useGetProductDetails = (reference) => {
  const { data, error, isLoading, isError, isFetching, refetch } = useQuery({
    queryKey: ['products', reference],
    queryFn: () => getProductDetails(reference),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    enabled: !!reference,
  });
  return { data, error, isLoading, isError, refetch, isFetching };
};
